var a;(function(l){l.CopyWalletAddress="copy_wallet_address",l.WalletExplorer="wallet_explorer",l.Logout="logout"})(a||(a={}));export{a as AddressWidgetButtons};
